import { APIService, ListSize, SupplierType } from "src/app/components/common/static-data-common";
import { commonDataSource } from "../booking/inspectionbooking.model";
import { summaryModel } from "../summary.model";
import { array } from "@amcharts/amcharts4/core";

export interface DataSource {
  id: number;
  name: string;
}

export interface ParentDataSource {
  id: number;
  name: string;
  parentId: number;
}
export enum ResponseResult {
  Success = 1,
  NoDataFound = 2,
  NotFound = 3,
  DuplicateData = 4,
  DuplicateName = 5,
  NameRequired = 6
}

export class DataSourceResponse {
  dataSourceList: Array<DataSource>;
  result: ResponseResult;
}

export class CommonDataSourceRequest {
  public searchText: string;
  public skip: number;
  public take: number;
  public customerId: number;
  public supplierId: number;
  public supplierType: number;
  public id: number;
  public idList: Array<number>;
  locationId: number;
  public supSearchTypeId: number;
  constructor() {
    this.searchText = "";
    this.skip = 0;
    this.take = ListSize;
    this.idList = [];
    this.supSearchTypeId = 0;
  }
}
export class UserDataSourceRequest {
  public searchText: string;
  public skip: number;
  public take: number;
  public customerId: number;
  public supplierId: number;
  public supplierType: number;
  public id: number;
  public idList: Array<number>;
  locationId: number;
  constructor() {
    this.searchText = "";
    this.skip = 0;
    this.take = ListSize;
    this.idList = [];
  }
}

export class CountryDataSourceRequest {
  public searchText: string;
  public skip: number;
  public take: number;
  public countryIds: Array<number>;
  public countryId?: number;
  public selectedCountryIds: Array<number>;
  public regionIds: Array<number>;
  constructor() {
    this.searchText = "";
    this.skip = 0;
    this.take = ListSize;
    this.countryIds = [];
    this.selectedCountryIds = [];
    this.regionIds = [];
  }
}

export class CommonSupplierSourceRequest {
  public searchText: string;
  public skip: number;
  public take: number;
  public countryIds: Array<number>;
  public supplierTypes: number;
  public id: number;
  public customerId: number;
  public provinceId: number;
  public cityIds: Array<number>;
  public isRegionalNameChecked: boolean;
  public active: boolean;
  constructor() {
    this.searchText = "";
    this.skip = 0;
    this.take = ListSize;
    this.countryIds = [];
    this.supplierTypes = null;
    this.cityIds = [];
  }
}

export class CommonCustomerSourceRequest {
  public searchText: string;
  public skip: number;
  public take: number;
  public customerId: number;
  public idList: Array<number>;
  constructor() {
    this.searchText = "";
    this.skip = 0;
    this.take = ListSize;
  }
}
export class CommonZoneSourceRequest {
  public searchText: string;
  public skip: number;
  public take: number;
  public zoneId: number;
  constructor() {
    this.searchText = "";
    this.skip = 0;
    this.take = ListSize;
  }
}
export class CommonOfficeZoneSourceRequest {
  public searchText: string;
  public skip: number;
  public take: number;
  public zoneId: number;
  public officeIds: Array<number>;
  constructor() {
    this.searchText = "";
    this.skip = 0;
    this.take = ListSize;
    this.officeIds = [];
  }
}
export class CommonCountySourceRequest {
  public searchText: string;
  public skip: number;
  public take: number;
  public cityId: number;
  public countyId: number;
  constructor() {
    this.searchText = "";
    this.skip = 0;
    this.take = ListSize;
  }
}

export class QcDataSourceRequest {
  public searchText: string;
  public skip: number;
  public take: number;
  public qcType: number;
  public qcIds: Array<number>;
  public officeCountryIds: Array<number>;
  public id: number;
  constructor() {
    this.searchText = "";
    this.skip = 0;
    this.take = ListSize;
    this.officeCountryIds = [];
    this.qcIds = [];
  }
}



export class CustomerDataSourceRequest {
  searchText: string;
  serviceId: number;
  skip: number;
  take: number;

  constructor() {
    this.serviceId = APIService.Tcf;
    this.skip = 0;
    this.take = 10;
    this.searchText = "";
  }
}

export class SupplierDataSourceRequest {
  searchText: string;
  customerIds: Array<number>;
  customerglCodes: Array<string>;
  serviceId: number;
  supplierIds: Array<number>;
  supplierType: number;
  skip: number;
  take: number;
  factoryId: number;
  supSearchTypeId: number;

  constructor() {
    this.serviceId = APIService.Inspection;
    this.skip = 0;
    this.take = 10;
    this.searchText = "";
    this.supplierType = SupplierType.Supplier;
    this.customerIds = [];
    this.supplierIds = [];
  }
}
export class ProductDataSourceRequest {
  searchText: string;
  customerIds: Array<number>;
  productIds: Array<number>;
  id: number;
  skip: number;
  take: number;
  supplierIdList: Array<number>;
  factoryIdList: Array<number>;

  constructor() {
    this.skip = 0;
    this.take = 10;
    this.searchText = "";
    this.customerIds = [];
    this.productIds = [];
    this.supplierIdList = [];
    this.factoryIdList = [];
  }
}

export class ProductDetailsDataSourceRequest {
  searchText: string;
  customerIds: Array<number>;
  id: number;
  skip: number;
  take: number;

  constructor() {
    this.skip = 0;
    this.take = 10;
    this.searchText = "";
    this.customerIds = [];
  }
}

export class BuyerDataSourceRequest {
  searchText: string;
  customerIds: Array<number>;
  customerglCodes: Array<string>;
  serviceId: number;
  buyerIds: Array<number>;
  skip: number;
  take: number;

  constructor() {
    this.serviceId = APIService.Inspection;
    this.skip = 0;
    this.take = 10;
    this.searchText = "";
  }
}

export class CustomerContactSourceRequest {
  searchText: string;
  customerIds: Array<number>;
  customerglCodes: Array<string>;
  contactTypeIds: Array<number>;
  serviceId: number;
  contactIds: Array<number>;
  skip: number;
  take: number;

  constructor() {
    this.serviceId = APIService.Inspection;
    this.skip = 0;
    this.take = 10;
    this.searchText = "";
  }
}


export class ProductCategorySourceRequest {
  searchText: string;
  serviceId: number;
  skip: number;
  take: number;

  constructor() {
    this.serviceId = APIService.Inspection;
    this.skip = 0;
    this.take = 10;
    this.searchText = "";
  }
}

export class ProductSubCategorySourceRequest {
  searchText: string;
  serviceId: number;
  productCategoryIds: Array<number>;
  skip: number;
  take: number;

  constructor() {
    this.serviceId = APIService.Inspection;
    this.skip = 0;
    this.take = 10;
    this.searchText = "";
  }
}

export class ProductSubCategory2SourceRequest {
  searchText: string;
  productCategoryId: number;
  productSubCategoryIds: Array<number>;
  productSubCategory2Ids: Array<number>;
  skip: number;
  take: number;

  constructor() {
    this.skip = 0;
    this.take = 10;
    this.searchText = "";
    this.productCategoryId = 0;
    this.productSubCategoryIds = [];
    this.productSubCategory2Ids = [];
  }
}


export class ProductSubCategory3SourceRequest {
  searchText: string;
  productCategoryId: number;
  productSubCategoryId: number;
  productSubCategory3Ids: Array<number>;
  productSubCategory2Ids: Array<number>;
  skip: number;
  take: number;

  constructor() {
    this.skip = 0;
    this.take = 10;
    this.searchText = "";
    this.productCategoryId = 0;
    this.productSubCategoryId = 0;
    this.productSubCategory3Ids = [];
    this.productSubCategory2Ids = [];
  }
}

export class ProvinceDataSourceRequest {
  public searchText: string;
  public skip: number;
  public take: number;
  public countryIds: Array<number>;
  public provinceId: number;
  constructor() {
    this.searchText = "";
    this.skip = 0;
    this.take = ListSize;
    this.countryIds = [];
  }
}

export class CityDataSourceRequest {
  public searchText: string;
  public skip: number;
  public take: number;
  public provinceId: number;
  public cityIds: Array<number>;
  public countryIds: Array<number>;
  constructor() {
    this.searchText = "";
    this.skip = 0;
    this.take = ListSize;
    this.cityIds = [];
  }
}

export class TownDataSourceRequest {
  public searchText: string;
  public skip: number;
  public take: number;
  public countyId: number;
  public townIds: Array<number>;
  public countryIds: Array<number>;
  constructor() {
    this.searchText = "";
    this.skip = 0;
    this.take = ListSize;
  }
}

export class UserServiceAccess {
  public id: number;
  public name: string;
  public userHasAccess: boolean;
  public serviceEnabledFileName: string;
  public serviceDisabledFileName: string;
  constructor() {
    this.userHasAccess = false;
    this.serviceEnabledFileName = "";
    this.serviceDisabledFileName = "";
  }
}

export class StartPortDataSourceRequest {
  public searchText: string;
  public skip: number;
  public take: number;
  public startPortIds: Array<number>;
  constructor() {
    this.searchText = "";
    this.skip = 0;
    this.take = ListSize;
  }
}

export class ProvinceListSearchRequest {
  countryIds: Array<number>;
}

export class CityListSearchRequest {
  provinceIds: Array<number>;
}

export class BookingIdDataSourceRequest {
  public searchText: string;
  public skip: number;
  public take: number;
  public ids: Array<number>;
  constructor() {
    this.searchText = "";
    this.skip = 0;
    this.take = ListSize;
  }
}


export class ProvinceListResponse {
  dataSourceList: Array<commonDataSource>;
  result: ProvinceResult;
}

export enum ProvinceResult {
  Success = 1,
  RequestShouldNotBeEmpty = 2,
  CountrySearchFilterEmpty = 3,
  DataNotFound = 4,
  Failed = 5
}

export class CityListResponse {
  dataSourceList: Array<commonDataSource>;
  result: ProvinceResult;
}

export enum CityResult {
  Success = 1,
  RequestShouldNotBeEmpty = 2,
  CountrySearchFilterEmpty = 3,
  DataNotFound = 4,
  Failed = 5
}


export class InvoiceReportTemplate {
  templateId: number;
}

export class InvoiceReportTemplateRequest {
  customerId: string;
  invoicePreviewTypes: string[];
  constructor() {
    this.invoicePreviewTypes = [];
  }
}

export class CommonRequest {
  searchText: string;
  selectedIds: Array<number>;
  Skip: number;
  Take: number
  constructor() {
    this.selectedIds = new Array<number>();
  }
}

export enum FBReportAccessType {
  Filling = 1,
  Review = 2,
  ViewFilling = 3
}

export class CommonCompanySourceRequest {
  public searchText: string;
  public skip: number;
  public take: number;
  public customerId: number;
  public idList: Array<number>;
  constructor() {
    this.searchText = "";
    this.skip = 0;
    this.take = ListSize;
  }
}

export class TestStandardRequest {
  searchText: string;
  selectedStandardIds: Array<number>;
  skip: number;
  take: number
  constructor() {
    this.searchText = "";
    this.skip = 0;
    this.take = ListSize;
    this.selectedStandardIds = new Array<number>();
  }
}
export class TestRegulationRequest {
  searchText: string;
  selectedStandardIds: Array<number>;
  selectedRegulationIds: Array<number>;
  skip: number;
  take: number
  constructor() {
    this.searchText = "";
    this.skip = 0;
    this.take = ListSize;
    this.selectedStandardIds = new Array<number>();
    this.selectedRegulationIds = new Array<number>();
  }
}
export enum FilterPoProductEnum {
  ProductByPo = 1,
  ProductByCustomer = 2
}

export class DefaultUrlRequest {

  public featureId: number;
  public RoleTypes: Array<number>;
  public UserType: number;
}

export interface SaveCustomerTableColumnsResponse {
  result: SaveCustomerTableColumnsResult;
}

export enum SaveCustomerTableColumnsResult {
  Success = 1,
  NotFound = 2,
  Other = 3
}

export interface CustomerTableColumnsRequest {
  pageId: number;
  columns: Column[];
}

export interface Column {
  columnId: number;
  sortOrder: number;
}
// In a file like customer-table-column.models.ts

export interface GetColumnsByUserIdResponse {
  columnId: number;
  columnName: string;
  columnHeader: string;
  isChildColumn: boolean;
  isRestricted: boolean;
  sortOrder: number | null;
}

export interface GetAllColumnsResponse {
  columnId: number;
  columnName: string;
  columnHeader: string;
  isChildColumn: boolean;
  isRestricted: boolean;
}
export class CustomFilterDaysRequest {
  pageId: number;
}
export enum GetResponseResult {
  Success = 1,
  NotFound = 2,
  Other = 3
}
export class FilterDataRequest {
  public id: number;
  public pageId: number;
  public name: string;
  public payload: string;
  public filterCount: number;
}

export class TemplateDataSourceRequest {
  public searchText: string;
  public skip: number;
  public take: number;
  public customerId: number;
  public selectedTemplateIds: Array<number>;
  constructor() {
    this.searchText = "";
    this.skip = 0;
    this.take = ListSize;
    this.customerId = null;
    this.selectedTemplateIds = [];
  }
}

export class CustomerCommonDataSourceRequest {
  public searchText: string;
  public skip: number;
  public take: number;
  public customerId: number;
  public supplierId: number;
  public supplierType: number;
  public id: number;
  public idList: Array<number>;
  locationId: number;
  public supSearchTypeId: number;
  public isStatisticsVisible: boolean;
  public isVirtualScroll: boolean;
  public isKpiPptVisible: boolean;
  public isDownloadInspectionReportVisible: boolean;
  constructor() {
    this.searchText = "";
    this.skip = 0;
    this.take = ListSize;
    this.idList = [];
    this.supSearchTypeId = 0;
    this.isStatisticsVisible = false;
    this.isVirtualScroll = true;
    this.isKpiPptVisible = false;
    this.isDownloadInspectionReportVisible = false;
  }
}

export class FilterDataToRemove {
  id: number;
  name: string;
}


export class LogInformation {
  public logRequest: Array<LogInformationRequest>;
}

export class LogInformationRequest {
  ReferenceId: number;
  Data: string;
  ActionType: string;
  PageId: number;
}

// Define a type for the differences
export interface Difference {
  property: string;
  oldValue: any;
  currentValue: any;
  changeType: ChangeType;
}

export enum ChangeType {
  Added,
  Updated,
  Deleted,
  None
}


export class LogDataSummeryModel extends summaryModel {
  public referanceId: number;
  public logType: number;
}
export class UserRightTypeAccess {
  public id: number;
  public name: string;
  public rightTypeFileName: string;
  constructor() {
    this.rightTypeFileName = "";
  }
}


export class RightType {
  id: number;
  name: string;
  service: number;
  isLanding: boolean;
  sort: number;
}
export enum MethodOfDistribution {
  Homogeneous = 1,
  Heterogeneous = 2
}
export enum RefRiskElementValueTypeEnum {
  Min_Max = 1,
  RiskCategory = 2,
  RejectReason = 3,
  Country = 4
}
export enum RefRiskElementTypeEnum {
  InspectionsCount = 1,
  ShipmentFulfillmentRate = 2,
  LabTestingReportCount = 3,
  ProductRisk = 4,
  TechnicalAudit = 5,
  PctFallInspection = 6,
  PctDefectInspection = 7,
  PctFailLabTestingReport = 8,
  PctRejectInspection = 9,
  CountryRisk = 10
}